import { render, staticRenderFns } from "./Main-preview.vue?vue&type=template&id=7fb06ea3&"
import script from "./Main-preview.vue?vue&type=script&lang=js&"
export * from "./Main-preview.vue?vue&type=script&lang=js&"
import style0 from "./Main-preview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports